module.exports = __webpack_public_path__ + "static/media/socials-linkedin-gray.14e61010.svg";